import React, { memo } from "react";
import Select from "react-select";

const CustomSelect = ({
  options = [],
  value = null,
  onChange,
  placeholder = "Select...",
  isClearable = false,
  isDisabled = false,
  isMulti = false,
  styles = {},
  className = "",
  ...props
}) => {
  const defaultStyles = {
    control: (base) => ({
      ...base,
      borderColor: "#ced4da",
      "&:hover": { borderColor: "#2684FF" },
      boxShadow: "none",
    }),

    option: (base, state) => ({
      ...base,
      color: "#333",
      backgroundColor: state.isFocused ? "#c5d5ff" : "white",
      cursor: "pointer",
    }),
    singleValue: (base) => ({
      ...base,
      color: "white", // Change the font color of the selected value
    }),
  };

  return (
    <Select
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      isClearable={isClearable}
      isDisabled={isDisabled}
      isMulti={isMulti}
      classNamePrefix="custom-select"
      className={className}
      styles={{ ...defaultStyles, ...styles }}
      {...props}
    />
  );
};

export default memo(CustomSelect);
